import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import './sass/app.scss'

import env from './env.js';

import store from './store';

import axios from 'axios'
import VueAxios from 'vue-axios'
import { global } from './global.js'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = env.BASE_URL;

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

function getHeaders() {
   return {
     Authorization: 'Bearer ' + 
     localStorage.getItem('token'),
     "Content-Type": "Content-Type:application/json",
   }  
}
var self = this;
Vue.axios.interceptors.response.use(response => {
   return response;
}, error => {
  if (error.response.status === 401) {

   self.$store.dispatch('logout')
     .then(() => {
       self.$router.push('/login');
     })
     .catch(err => {
       console.log(err);
       self.isLoading = false;
     })

   localStorage.removeItem('token');
   self.$router.push('/login');
  }
  return error;
});

Vue.axios.defaults.headers = getHeaders();

Vue.prototype.$globals = global;

new Vue({
  router,
  global,
  store,
  mounted() {
  },
  render: h => h(App)
}).$mount('#app')
